import React from 'react'
import {motion} from 'framer-motion'

const Middle = () => {
    
  return (
    <section className='max-w-[1140px] mx-auto xl:container px-3 md:px-0 flex justify-center py-24 '>
        <div className='grid md:grid-cols-2 gap-2'>
             {/* text */}
        <div className='flex flex-col justify-center gap-3 '>
            {/* intro */}
            <h1 className='text-2xl md:text-7xl font-light'>Get The Best Experience</h1>
            <motion.div
            initial={{opacity:0,height:0}}
            whileInView={{opacity:1,height:1}}
            transition={{delay:0.3,duration:0.7}}
            >           
            <p className='text-[14px] w-10/12 text-justify py-3'>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Explicabo at voluptates similique earum labore? Necessitatibus nesciunt eum esse dolores ipsam eligendi possimus magnam. Totam, nihil veritatis eum dolore itaque quas!</p>
            </motion.div>
        </div>
        {/* image */}
        <div className='grid grid-cols-3 gap-2'>
            <motion.img src="https://images.pexels.com/photos/934069/pexels-photo-934069.jpeg?auto=compress&cs=tinysrgb&w=600" alt="" 
            className='w-[400px] rounded-xl shadow-2xl col-span-3'
            initial={{opacity:0,scale:0}}
            whileInView={{scale:1,opacity:1}}
            transition={{delay:0.1,duration:0.7}}
            />
            <motion.img src="https://images.pexels.com/photos/934063/pexels-photo-934063.jpeg?auto=compress&cs=tinysrgb&w=600" alt=""
            className='w-[300px] rounded-xl'
            initial={{opacity:0,height:0}}
            whileInView={{height:"140px",opacity:1}}
            transition={{delay:0.4,duration:0.7}}
            />
            <motion.img src="https://images.pexels.com/photos/1884579/pexels-photo-1884579.jpeg?auto=compress&cs=tinysrgb&w=600" alt=""
            className='w-[300px] rounded-xl'
            initial={{opacity:0,scale:0}}
            whileInView={{scale:1,opacity:1}}
            transition={{delay:0.1,duration:0.7}}
            />
            <motion.img src="https://images.pexels.com/photos/1082528/pexels-photo-1082528.jpeg?auto=compress&cs=tinysrgb&w=600" alt=""
            className='w-[300px] rounded-xl'
            initial={{opacity:0}}
            whileInView={{rotate:360,opacity:1}}
            transition={{delay:0.4,duration:0.9}}
            />
        </div>

        </div>
       
      
    </section>
  )
}

export default Middle
